<template>
  <ContentBlock required>
    <div slot="instructions">
      <h5>{{ $t('End User License Agreement') }}</h5>
      <p>{{ $t('The best practice is to produce a EULA with your professional legal advisor specifically drafted for your content and jurisdiction.') }}</p>
    </div>
    <div>
      <div class="updates" v-if="contentOwnership.status === 'active'">
        <div>
          <div class="f8">{{ $t('Latest EULA update') }}</div>
          <div class="f5">{{ latestUpdate }}</div>
        </div>
        <div
          v-if="contentOwnership.upcomingAgreement && contentOwnership.upcomingAgreement.startsAt"
          class="next-update"
        >
          <div class="f8">{{ $t('EULA effective date') }}</div>
          <div class="f5">{{ nextUpdate }}</div>
        </div>
      </div>
      <div class="label f8">{{ $t('Your End User License Agreement') }}<span class="required">*</span></div>
      <Editor
        api-key="jol745g2sbve3lxoc4hddsq05oyqzk3hmgrnlvjcxwwbriex"
        v-model="eulaModel"
        :init="init"
        @onInit="onTinyMCELoaded"
      />
      <Loading v-if="loadingEULA" />
    </div>
  </ContentBlock>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import ContentBlock from '@/core/shared/components/ContentBlock';
import Loading from '@/core/shared/components/Loading';
import Editor from '@tinymce/tinymce-vue';
import moment from 'moment-timezone';

@Component({
  components: {
    ContentBlock,
    Editor,
    Loading,
  },
  props: {
    contentOwnership: {
      type: Object,
      required: true,
    },
  },
  watch: {
    contentOwnership: {
      handler: 'onContentOwnershipChanged',
      immediate: false,
      deep: false,
    },
  },
})
export default class EULA extends Vue {
  loadingEULA = true;

  get eulaModel () {
    if (this.contentOwnership.upcomingAgreement) {
      return this.contentOwnership.upcomingAgreement.content;
    } else if (this.contentOwnership.currentAgreement) {
      return this.contentOwnership.currentAgreement.content;
    }
  }

  set eulaModel (value) {
    this.$emit('edit:contentOwnership', 'upcomingAgreement', {
      ...this.contentOwnership.upcomingAgreement,
      content: value,
    });
  }

  get latestUpdate () {
    if (this.contentOwnership.currentAgreement) {
      return moment(this.contentOwnership.currentAgreement.startsAt).format('LL');
    }
  }

  get nextUpdate () {
    if (this.contentOwnership.upcomingAgreement) {
      return moment(this.contentOwnership.upcomingAgreement.startsAt).format('LL');
    }
  }

  init = {
    height: 500,
    menubar: false,
    block_formats: 'Paragraph=p; Header 1=h1; Header 2=h2; Header 3=h3; Header 4=h4; Header 5=h5; Header 6=h6',
    plugins: [
      'advlist autolink lists link image charmap print preview anchor textcolor',
      'searchreplace visualblocks fullscreen',
      'insertdatetime media table contextmenu paste help wordcount',
    ],
    toolbar: 'insert | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist | removeformat | help',
  }

  created () {
    this.onContentOwnershipChanged();
  }

  onTinyMCELoaded () {
    this.loadingEULA = false;
  }

  onContentOwnershipChanged () {
    if (this.contentOwnership.status !== 'active' && !this.contentOwnership.upcomingAgreement) {
      const upcomingAgreement =
        (!this.contentOwnership.currentAgreement) ? { content: '' } : { content: this.contentOwnership.currentAgreement.content };
      this.$emit('edit:contentOwnership', 'upcomingAgreement', upcomingAgreement);
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "core/shared/styles";

.updates {
  margin-bottom: var(--spacingMd);

  @media (--tablet) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: var(--spacingSm);
  }

  & .f8 {
    color: var(--colorManatee);
  }
}

.required {
  color: var(--colorSBRedFlat);
}

.label {
  margin-bottom: var(--spacingXS);
}
</style>
